import { fetchData } from './fetchData';
import { Permission } from '../data/Permission';

type PermissionRequestData = {
    line_uid: string,
    login: string,
};

function permission(data: PermissionRequestData): Promise<Permission> {
    return fetchData(`api/permission?line_uid=${data.line_uid}&login=${data.login}`, {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: Permission) => resData);
}

export { permission };
